<app-modal [header]="'Bloquear Conta'"
           [isShow]="displayModal"
           [style]="'w-full max-w-lg h-grow'"
           (cancel)="displayModal = false; this.onCancelModal.emit();">

  <div>

    <div class="text-xs mb-10 space-y-2"><p>Utilize o campo abaixo e escolha a duração do tempo de bloqueio para o
      utilizador {{user.firstname}} {{user.lastname}} ({{user.email}}) </p></div>

    <form method="POST" class="space-y-4" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="my-10 space-y-8">

        <div>
          <app-select-input [formGroup]="form" id="duration" [options]="durations"
                            [formError]="formErrors.get('duration')"
                            placeholder="Duração do bloqueio" label="Duração"
          ></app-select-input>
        </div>

        <div>
          <app-text-area-input [formGroup]="form" [id]="'motive'" [label]="'Motivo'" [placeholder]="'Motivo do bloqueio'"
                               [maxLength]="250" [value]="form.value?.motive"
                               [formError]="formErrors.get('motive')">
          </app-text-area-input>
        </div>

      </div>

      <hr>

      <!-- submit button -->
      <div class="flex justify-end">
        <app-ae-button variant="danger" label="Bloquear" [loading]="isLoading"
                  (buttonClick)="onSubmit()" size="sm" styleClass="justify-end"></app-ae-button>
      </div>
    </form>
  </div>


</app-modal>


